import axios from "axios";
import config from "../config";
import { ApiSuccess } from "./api_helper";

const apiBase = config.api.API_URL;

/** GET /api/v1/sending/warmup — hub Entregabilidade (LAC-125). */
export type WarmupPlan = {
  stage: "new" | "warming" | "trusted" | string;
  sent_today: number;
  daily_cap: number | null;
  remaining_today: number | null;
  circuit_open?: boolean;
  suggestion: {
    today_target: number | null;
    tip_keys: string[];
    next_stage: string | null;
    progress: {
      sent_in_window: number;
      needed: number;
      window_days: number;
      hard_bounce_rate: number | null;
    } | null;
  };
};

export const getWarmupPlan = (): Promise<ApiSuccess<WarmupPlan>> => {
  return axios.get(apiBase + "/sending/warmup");
};
